import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "https://posthog.com/docs/integrate/server/go"
      }}>{`posthog-go`}</a>{` does not yet support feature flags with groups.`}</p>
    <p>{`Missing this? `}<a parentName="p" {...{
        "href": "https://github.com/PostHog/posthog/issues"
      }}>{`Let us know`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      